import { Lightning, Router, Utils } from '@lightningjs/sdk';
import configs from "../../../lib/configs";
import ThemeCustomizer from './ThemeCustomizer';

interface ColorTrayIconTemplateSpec extends Lightning.Component.TemplateSpecLoose {
  Icon: object;
}

export class ColorTrayIcon extends Lightning.Component<ColorTrayIconTemplateSpec> {
  static override _template(): Lightning.Component.Template<ColorTrayIconTemplateSpec> {
    return {
      x: 1850,
      y: 40,
      w: 50,
      h: 50,
      collision: true,
      zIndex: 9999,
      alpha: configs.demo === true ? 1 : 0,
      visible: configs.demo === true,
      Icon: {
        x: 0,
        y: 0,
        w: 47,
        h: 47,
        collision: true,
        src: Utils.asset('images/color-wheel.png'),
        scale: 1.0
      }
    };
  }

  protected _focusable = true;

  _toggleThemeCustomizer() {
    const themeCustomizer = this.parent?.getByRef('Widgets')?.getByRef('ThemeCustomizer');  
    
    if (themeCustomizer) {
      if (ThemeCustomizer.isOpen) {
        themeCustomizer.close();
      } else {
        themeCustomizer.open();
        Router.focusWidget('ThemeCustomizer');
      }
    }
  }

  override _handleEnter() {
    this._toggleThemeCustomizer();
    return true;
  }

  _handleClick() {
    this._toggleThemeCustomizer();
    return true;
  }

  override _focus() {
    const icon = this.tag('Icon');
    if (icon) {
      icon.patch({
        smooth: {
          scale: 1.1
        }
      });
    }
  }

  override _unfocus() {
    const icon = this.tag('Icon');
    if (icon) {
      icon.patch({
        smooth: {
          scale: 1.0
        }
      });
    }
  }
}

export default ColorTrayIcon;
